import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SETTINGS, Settings } from '../../app.settings';
import { isEmpty, isStringEmpty } from '../../common/functions';

@Injectable({
  providedIn: 'root'
})
export class InsectaServiceBase {
  baseUrl: string = `https://localhost:44382/app/`;
  constructor(
    protected httpClient: HttpClient,
    @Inject(SETTINGS) protected settings: Settings
  ) {
    this.baseUrl = `${settings.baseUrl}/app/`;
  }

  protected delete<T>(endpoint: string, version: string): Observable<T> {
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    if (isStringEmpty(version)) version = `v1`;
    return this.httpClient.delete<T>(`${this.baseUrl}${version}${endpoint}`, { headers: headers });
  }

  protected get<T>(endpoint: string, version: string): Observable<T> {
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };

    if (isStringEmpty(version)) version = `v1`;
    return this.httpClient.get<T>(`${this.baseUrl}${version}${endpoint}`, { headers: headers });
  }

  protected fetchBlob(endpoint: string, version: string, content: any): Observable<Blob> {
    const headers = {
      'Accept': 'application/octet-stream',
      'Content-Type': 'application/json'
    };
    if (isEmpty(version)) version = `v1`;
    return this.httpClient.post(`${this.baseUrl}${version}${endpoint}`, content, { headers: headers, responseType: 'blob' });
  }

  protected post<T>(endpoint: string, version: string, content: any): Observable<T> {
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    if (isEmpty(version)) version = `v1`;
    return this.httpClient.post<T>(`${this.baseUrl}${version}${endpoint}`, content, { headers: headers });
  }

  protected postFormData<T>(endpoint: string, version: string, content: FormData): Observable<T> {
    const headers = {
      'Accept': 'application/json'
    };
    if (isStringEmpty(version)) version = `v1`;
    return this.httpClient.post<T>(`${this.baseUrl}${version}${endpoint}`, content, { headers: headers });
  }

  protected patch<T>(endpoint: string, version: string, content: any): Observable<T> {
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    if (isStringEmpty(version)) version = `v1`;
    return this.httpClient.patch<T>(`${this.baseUrl}${version}${endpoint}`, content, { headers: headers });
  }

  protected put<T>(endpoint: string, version: string, content: any): Observable<T> {
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    if (isStringEmpty(version)) version = `v1`;
    return this.httpClient.put<T>(`${this.baseUrl}${version}${endpoint}`, content, { headers: headers });
  }
}
